import { createFileRoute } from "@tanstack/react-router";
import OhioHealthyInsurance, { config } from "@/pages/OhioHealthyInsurance";
import { buildInsuranceSchema } from "@/components/InsurancePageTemplate";
export const Route = createFileRoute("/ohio-healthy-insurance")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Ohio Healthy TMS Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Ohio Healthy insurance coverage for TMS, SAINT TMS, and SPRAVATO. Benefits verification for depression treatment in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:title",
          content: "Ohio Healthy TMS Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Ohio Healthy insurance coverage for TMS, SAINT TMS, and SPRAVATO. Benefits verification for depression treatment in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/ohio-healthy-insurance",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/ohio-healthy-insurance",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(buildInsuranceSchema(config)),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <OhioHealthyInsurance />;
}
